<template>
  <v-dialog
    v-model="showDialogOrderExportSettings"
    width="400"
    scrollable
    :fullscreen="$mq === 'xs'"
    :persistent="exporting"
  >
    <v-card :tile="$mq === 'xs'">
      <v-card-title class="blue darken-2 white--text">
        <h2 class="text-h4 mb-1 mx-auto">
          Export Settings
        </h2>
      </v-card-title>

      <v-card-text class="pt-6 pb-8">
        <v-checkbox
          v-model="itemized"
          label="Include Order Items"
          dense
          persistent-hint
          hint="Uncheck this to export Order data without Line Items. (Helpful to calculate totals like subtotal, tips, taxes, etc.)"
        />
        <h3 class="pt-3"
          >Please contact support at
          <a href="mailto:hi@getminimart.com">hi@getminimart.com</a> for
          additional export options.</h3
        >
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          @click="exportCSV"
          depressed
          class="white--text"
          color="blue darken-2"
          large
          :loading="exporting"
          >Export</v-btn
        >
        <v-btn
          @click="showDialogOrderExportSettings = false"
          large
          outlined
          :disabled="exporting"
          color="grey darken-1"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
    <a ref="downloadLink" class="d-none" :href="linkHref">CSV Download Link</a>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import Laravel from '@/services/Laravel'
import { format } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'

export default {
  name: 'DialogOrderExportSettings',
  components: {},
  methods: {
    async exportCSV() {
      this.exporting = true

      await this.resetExportParams()
      try {
        let endpointParts = ['shops', this.getShopId, 'orders']
        if (this.itemized) {
          endpointParts.push(`itemized`)
        }
        endpointParts.push(`export`)
        let { data: exportedCSV } = await Laravel.get(
          endpointParts.join('/'),
          { params: this.tableFetchOptions },
          {
            headers: {
              // 'Content-Type': 'text/csv',
              Accept: 'text/csv',
            },
          }
        )
        this.exportSuccess = true
        this.showExportSuccessSnackbar = true
        await this.setupDownloadLink(exportedCSV)
        await this.$refs.downloadLink.click()
      } catch (error) {
        this.error = error
      } finally {
        this.exporting = false
      }
    },
    resetExportParams() {
      this.exportSuccess = false
      this.showExportSuccessSnackbar = false
      this.linkHref = ''
      this.$refs.downloadLink.setAttribute('download', '')
    },
    setupDownloadLink(exportedCSV) {
      const blob = new Blob([exportedCSV])
      this.linkHref = window.URL.createObjectURL(blob)
      const date = format(Date.now(), TimeFormats.dateAndTimeForFiles)

      this.$refs.downloadLink.setAttribute(
        'download',
        `Orders-Export${this.itemized ? '-itemized' : ''}_${date}.csv`
      )
    }, // setupDownloadLink
  },
  computed: {
    ...mapGetters('shop', ['getShopId']),
    ...mapFields('admin', [
      'tableFetchOptions',
      'showDialogOrderExportSettings',
    ]),
    ...mapFields('snackbars', ['showExportSuccessSnackbar']),
  },
  created() {},
  data() {
    return {
      exporting: false,
      exportSuccess: false,
      linkHref: '',
      itemized: true,
    }
  },
}
</script>
